import clsx from "clsx"
import {useField, useFormikContext} from "formik"
import {NumericFormat, NumericFormatProps} from "react-number-format"

import {cFormGroupProps} from "../../utils";

import FormGroup from "./FormGroup";

interface FormInputNumberProps extends cFormGroupProps, NumericFormatProps {
  name: string;
  placeholder?: string;
}

function FormInputNumber(
  {
    extraClassName,
    formGroupStyle,
    type,
    labelText,
    labelIsHidden,
    name,
    placeholder,
    inputGroupText,
    inputGroupPlacement,
    formGroupExtraContent,
    helpText,
    hideError,
    max,
    ...rest
  }: FormInputNumberProps) {
  const { setFieldValue } = useFormikContext()
  const [field, meta] = useField(name)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    const numericValue = value.replace(/[^\d.]/g, '')
    // Convert to number, or set to 0 if empty/invalid
    const numberValue = numericValue === '' ? 0 : parseFloat(numericValue)
    setFieldValue(name, numberValue)

    // // Call Formik's original onChange
    // field.onChange(event);
  }

  return (
    <FormGroup
      extraClassName={clsx("c-form-group-number", extraClassName && extraClassName)}
      formGroupStyle={formGroupStyle}
      name={name}
      labelText={labelText}
      labelIsHidden={labelIsHidden}
      inputGroupText={inputGroupText}
      inputGroupPlacement={inputGroupPlacement}
      formGroupExtraContent={formGroupExtraContent}
      helpText={helpText}
      hideError={hideError}
      hasErrors={meta.touched && meta.error}
      errorText={meta.error}
    >

      <NumericFormat
        {...field}
        {...rest}
        displayType="input"
        id={`id_${name}`}
        name={name}
        placeholder={placeholder ? placeholder : ""}
        thousandSeparator=","
        decimalSeparator="."
        valueIsNumericString={true}
        aria-invalid={!!(meta.touched && meta.error)}
        onChange={handleChange}
        decimalScale={rest.decimalScale || 2}
        fixedDecimalScale={rest.fixedDecimalScale !== false}
        style={{
          fontFamily: 'SF Mono, Monaco, Consolas, Liberation Mono, Courier New, monospace',
          fontVariantNumeric: 'tabular-nums',
          textAlign: 'right',
          ...rest.style
        }}
      />

    </FormGroup>
  )
}

export default FormInputNumber